<template>
  <img
    src="@/assets/Shape.svg"
    class="logo-background"
  />
</template>
<script>

export default {
  name: 'LogoBackground'
}

</script>
<style scoped>
  .logo-background {
    margin-top: 5rem;
    z-index: 100;
  }
</style>
